import { bindServices } from '@/services/api';

const api = bindServices('sequenceTracing');
import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import { merge } from 'lodash';

const { ManageSequenceTracing } = CoreQueries;

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'sequenceTracing',

  state: {
    list: [],
    orderBy: '',
    pagination: { ...meta },
    searchTable: '',
    selectedItem: {},
    openCreateOrEdit: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const params = { route: 'sequenceTrace', ...payload, ...ManageSequenceTracing.paged };
        const response = yield call(api.getPerPaged, params);
        yield put({
          type: 'queryList',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
            searchTable: payload.search,
          },
        });
      } catch (error) {}
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryList(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: merge(state.pagination, toPaginate(payload)),
        searchTable: payload.searchTable ? payload.searchTable : '',
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        orderBy: '',
      };
    },
  },
};

export default Model;
